
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
/*
Base UI includes { ng-zorro } as the base ui library
- Check https://ng.ant.design/docs/introduce/en for getting started with components
- Check /app/sandbox for UI samples 
*/
import { NgZorroAntdModule } from 'app/ng-zorro.module';

/* RICH TEXT EDITOR -- DEMO -- CHANGE AS DESIRED (Quill)*/
import { AngularEditorModule } from '@kolkov/angular-editor';

//Routing Module for the specific View Module

// count up animation
import { CountUpModule } from 'countup.js-angular2';
import { CustomPipesModule } from 'app/BaseFramework/shared/custom-pipes/custom-pipes.module';
import { TransactionRoutingModule } from './transaction-routing.module';
import { TransactionDetailsComponent } from './transaction-details/transaction-details.component';
import { SharedComponentsModule } from 'app/ViewModules/shared-components';
import {DragDropModule} from '@angular/cdk/drag-drop'
import {
  AngularImageViewerModule
} from "angular-x-image-viewer";

const _components = [TransactionDetailsComponent]

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DragDropModule,
    ReactiveFormsModule,
    AngularEditorModule,
    NgZorroAntdModule,
    SharedComponentsModule,
    TransactionRoutingModule,
    CountUpModule,
    CustomPipesModule,
    AngularImageViewerModule
  ],
  declarations: [..._components],
  exports: [..._components]
})
export class TransactionNBUModule { }
